import React from 'react';
import PropTypes from 'prop-types';
import LockIcon from './icons/LockIcon';

const CertificateLockOverlay = ({ message, title, onClick, buttonMessage }) => (
    <div className="lockOverlay-container" style={{ zIndex: 10 }}>
      <div className="content-container">
        <div className="lock-icon-container">
          <LockIcon width={50} height={50} />
        </div>
        <div className="lock-info">
          <h5 className="lock-title">{title}</h5>
          <span className="lock-message">{message}</span>
          {onClick && (
            <button
              className="btn btn-dynamic lock-btn"
              type="button"
              onClick={onClick}
            >
              {buttonMessage}
            </button>
          )}
        </div>
      </div>
    </div>
  );

CertificateLockOverlay.propTypes = {
  message: PropTypes.string,
  title: PropTypes.string,
  onClick: PropTypes.func,
  buttonMessage: PropTypes.string,
};

CertificateLockOverlay.defaultProps = {
  message: '',
  title: '',
  onClick: null,
  buttonMessage: '',
};

export default CertificateLockOverlay;
